import { render, staticRenderFns } from "./UploadSettings.vue?vue&type=template&id=879c72a2&"
import script from "./UploadSettings.vue?vue&type=script&lang=js&"
export * from "./UploadSettings.vue?vue&type=script&lang=js&"
import style0 from "./UploadSettings.vue?vue&type=style&index=0&id=879c72a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports